export const GLOBAL_FILTER_VALUE = {
  activeFilters: {},
  search: null,
  filterUserTrials: false,
  exclusive: {},
};

export const TBD = '';
